var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1339 6.00034C10.1339 7.17854 9.17879 8.13366 8.00059 8.13366C6.82239 8.13366 5.86727 7.17854 5.86727 6.00034C5.86727 4.82214 6.82239 3.86702 8.00059 3.86702C9.17879 3.86702 10.1339 4.82214 10.1339 6.00034Z",
    fill: "#849291"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5196 2.06883C13.8022 2.89716 14.9466 4.05581 15.8286 5.4198C15.9399 5.59237 15.9994 5.79327 16 5.99864C16.0006 6.20402 15.9422 6.40525 15.8319 6.57846C14.9532 7.95378 13.8112 9.11678 12.5292 9.94244C11.1163 10.8521 9.54626 11.3331 7.98928 11.3331C6.39729 11.3331 4.8673 10.8664 3.44564 9.94544C2.18298 9.12844 1.04999 7.96812 0.169664 6.59046C0.0553699 6.41313 -0.003626 6.20583 0.000172543 5.99489C0.00397108 5.78395 0.0703926 5.5789 0.190997 5.4058C1.25932 3.87415 2.48931 2.68449 3.84697 1.87016C5.1783 1.0715 6.57195 0.666504 7.98928 0.666504C9.53393 0.666504 11.1006 1.1515 12.5196 2.06883ZM6.2228 8.66048C6.74903 9.0121 7.36771 9.19978 8.00061 9.19978C8.849 9.19881 9.66236 8.86136 10.2623 8.26145C10.8622 7.66155 11.1996 6.84819 11.2006 5.9998C11.2006 5.3669 11.0129 4.74822 10.6613 4.22199C10.3097 3.69575 9.80991 3.2856 9.22519 3.04341C8.64047 2.80121 7.99706 2.73784 7.37632 2.86131C6.75559 2.98478 6.18541 3.28955 5.73788 3.73707C5.29036 4.1846 4.98559 4.75478 4.86212 5.37551C4.73865 5.99625 4.80202 6.63966 5.04422 7.22438C5.28641 7.8091 5.69656 8.30887 6.2228 8.66048Z",
    fill: "#849291"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.49fe660488a1b8ce8d254423517a466e.svg";
export { ForwardRef as ReactComponent };